import { useState, useEffect } from 'react';
import Button from 'components/Globals/Base/Button';
import SearchInput from 'components/Globals/SearchInput';
import CustomLink from 'components/Globals/Base/Link';

import * as S from './CompanySearch.styles';

interface CompanySearchProps {
  placeholder: string;
  searchTerm: string;
  mostPopular: { href: string; label: string }[];
  onSearch: (value: string) => void;
  onClear: () => void;
  className?: string;
  dataCy?: string;
}

const CompanySearch = ({
  placeholder,
  mostPopular,
  onSearch,
  onClear,
  searchTerm,
  className = '',
  dataCy = '',
}: CompanySearchProps) => {
  const [searchValue, setSearchValue] = useState(searchTerm);

  useEffect(() => {
    setSearchValue(searchTerm);
  }, [searchTerm]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchValue.trim()) {
      onSearch(searchValue);
    }
  };
  const handleClear = () => {
    setSearchValue('');
    onClear();
  };

  return (
    <S.Wrapper className={className}>
      <form
        className='search-bar'
        onSubmit={handleSearch}
      >
        <SearchInput
          className='search-input'
          placeholder={placeholder}
          value={searchValue}
          onChange={(value) => setSearchValue(value)}
          onClear={handleClear}
        />

        <Button
          className='search-button'
          type='submit'
          hasRightArrow={false}
          size={{ default: 'large' }}
          dataCy='search-button'
        >
          Search
        </Button>
      </form>
      {mostPopular.length > 0 && (
        <S.PopularSearches data-cy='most-popular-searches'>
          <span data-cy={`${dataCy}-most-popular-label`}>Most Popular:</span>
          {mostPopular.map((popular, index) => (
            <CustomLink
              key={popular.href}
              href={popular.href}
              type='blueSecondary'
              className='popular-search'
              dataCy={`${dataCy}-most-popular-${index}`}
            >
              {popular.label}
            </CustomLink>
          ))}
        </S.PopularSearches>
      )}
    </S.Wrapper>
  );
};

export default CompanySearch;
